import React from 'react';
import {Responsive} from 'admin-on-rest';
import {
    TableRow,
    TableHeaderColumn,
} from 'material-ui/Table';
import FuseTheme from "../global/theme";

const styles = {
    rowHeight: {height: '40px'},
    label: {display: 'block', fontSize: 12, color: FuseTheme.palette.lightTextColor, margin: '10px 0 5px 0'},
    icon: {height: '40px', padding: '10px', overflow: 'inherit'}
};

const TransactionTableHeaderRow = () => (
    <Responsive
        small={
            <TableRow>
                <TableHeaderColumn>
                    Transactions
                </TableHeaderColumn>
            </TableRow>
        }
        medium={
            <TableRow style={styles.rowHeight}>
                <TableHeaderColumn>Date</TableHeaderColumn>
                <TableHeaderColumn>ID</TableHeaderColumn>
                <TableHeaderColumn>Reward Points<br/>(Type)</TableHeaderColumn>
            </TableRow>
        }
        large={
            <TableRow style={styles.rowHeight}>
                <TableHeaderColumn colSpan={2}>Date</TableHeaderColumn>
                <TableHeaderColumn colSpan={2}>Transaction ID</TableHeaderColumn>
                <TableHeaderColumn>Reward Points</TableHeaderColumn>
                <TableHeaderColumn>Type</TableHeaderColumn>
            </TableRow>
        }
    />
);

export default TransactionTableHeaderRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransactionTableHeaderRow.js